export enum TimePeriods {
    Default = -5,
    UntilRefocus = -3,
    UntilRest = -2,
    Permanent = -1,
    NoTurn = 0,
    UntilResolved = 1,
    UntilOtherCharactersTurn = 2,
    UntilResolvedAndOtherCharactersTurn = 3,
    HalfTurn = 5,
    Turn = 10,
    Minute = 100,
    TenMinutes = 1000,
    Hour = 6000,
    EightHours = 48000,
    Day = 144000,
}
